export const isEmailValid = (str?: string) => {
  if (!str) {
    return false;
  }
  const cleanString = str.trim();
  return (
    cleanString.length > 0 &&
    cleanString.lastIndexOf('@') > 0 &&
    cleanString.lastIndexOf('.') < cleanString.length - 1 &&
    cleanString.lastIndexOf('.') > cleanString.lastIndexOf('@') + 1 &&
    !cleanString.includes(' ')
  );
};

export const sanitizeEmail = (str: string) => str.trim().toLowerCase();

export const getEmailDomain = (emailStr: string) => sanitizeEmail(emailStr).split('@')[1];

export const areEmailsEqual = (email1: string, email2: string) => {
  const sanitizedEmail1 = sanitizeEmail(email1);
  const sanitizedEmail2 = sanitizeEmail(email2);
  return sanitizedEmail1.localeCompare(sanitizedEmail2, undefined, {sensitivity: 'base'}) === 0;
};

export const findByEmail = <T extends {email: string}>(items: T[], email: string) =>
  items.find((item) => areEmailsEqual(item.email, email));
